import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import '../modal.css'

interface DowngradeConfirmModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isDowngrading: boolean
}

const PaymentConfirmModal: React.FC<DowngradeConfirmModalProps> = ({ show, onHide, onConfirm, isDowngrading }) => {
  const { t } = useTranslation('plan')
  return (
    <div className='custom_modal'>
      <Modal
        show={show}
        onHide={isDowngrading ? undefined : onHide}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        className='common_modal_main_div'
        backdrop={isDowngrading ? 'static' : true}
        keyboard={!isDowngrading}
      >
        <Modal.Body className='mobile_align_div'>
          <div className='modal_title_div'>
            <h4 className='modal_heading'>{t('billingModals.confirmDowngrade.title')}</h4>
          </div>
          <div className='downgrade-modal-content'>
            <p>{t('billingModals.confirmDowngrade.body')}</p>
          </div>
          <div className='downgrade-modal-buttons'>
            <button className='btn btn-outline-secondary' onClick={onHide} disabled={isDowngrading}>
              {t('billingModals.confirmDowngrade.cancel')}
            </button>
            <button className='btn btn-success downgrade-confirm-btn' onClick={onConfirm} disabled={isDowngrading}>
              {isDowngrading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                  {t('billingModals.confirmDowngrade.downgrading')}
                </>
              ) : (
                t('billingModals.confirmDowngrade.downgrade')
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default PaymentConfirmModal
